import PhotoIcon from '@mui/icons-material/Photo';
import React from 'react';
import { GetImageMeta as GetImageMetaService } from '../../../../../services/2talk/omnichannel';
import ChatMessageImageDialog from './message-type-dialog/chat-message-image-dialog';
import './styles.css';

const hasValidMessageId = (id) => {
  const normalizedId = `${id ?? ''}`.trim().toLowerCase();
  return normalizedId !== '' && normalizedId !== 'undefined' && normalizedId !== 'null';
}

function ChatMessageImage({ content, id, setLoading, src, title }) {
  const [openDialog, setOpenDialog] = React.useState(false)
  const [url, setUrl] = React.useState("")
  const canOpenAttachment = hasValidMessageId(id)

  React.useEffect(() => {
    return () => {
      setUrl('');
      setOpenDialog(false);
    };
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const download = async e => {
    e.preventDefault()
    if (!canOpenAttachment) return

    if (e.target.classList.contains('omnichannel-chat-message-image') || e.target.classList.contains('omnichannel-chat-message-image-icon') || e.target.classList.contains('omnichannel-chat-message-image-name')) {
      if (openDialog) return

      setLoading(true)
      let result = await GetImageMetaService(id)
      if (result && result.success && result.data && result.data.url) {
        setUrl(result.data.url)
        setTimeout(() => {
          setOpenDialog(true)
          setLoading(false)
        }, 1000)
      } else 
        setLoading(false)
    }
  }
  const shortenUrl = (url, max = 40) => {
    if (!url) return "";
    if (url.length <= max) return url;
    
    const start = url.substring(0, 20);
    const end = url.substring(url.length - 10);
    return `${start}...${end}`;
  };

  return (<div
      className={`omnichannel-chat-message-image${canOpenAttachment ? '' : ' omnichannel-chat-message-attachment-disabled'}`}
      onClick={download} >
    <div className="omnichannel-chat-message-image-icon" >
      <PhotoIcon style={{ color: '#545454', fontSize: '3em' }} />
    </div>
    <div className="omnichannel-chat-message-image-name" >
 
      {shortenUrl(content)}.png
      {!canOpenAttachment && <span className="omnichannel-chat-message-attachment-status">Enviando anexo...</span>}
    </div>
    { (url && url.length > 0) && <ChatMessageImageDialog
      url={url}
      title={shortenUrl(title)}
      isOpen={openDialog}
      handleCloseDialog={handleCloseDialog} />}
  </div>)
}

export default React.memo(ChatMessageImage)
